module.exports = __webpack_public_path__ + "static/media/7en.1ebc1380.jpg";